<template>
  <div id="app">
    <!--    <el-dialog :visible.sync="open" width="80vw">-->
    <!--&lt;!&ndash;      <el-image :src="imageSrc" @load="imageLoaded" @error="imageLoadError" style="width: 1000px;" />&ndash;&gt;-->
    <!--      <video :src="require('@/assets/video/newYear.mp4')" ref="videoPlayer" @ended="onVideoEnded" muted autoplay style="width: 100%;" />-->
    <!--&lt;!&ndash;      <div class="img_newYear">&ndash;&gt;-->
    <!--&lt;!&ndash;        <h1 v-if="title1">格物智安</h1>&ndash;&gt;-->
    <!--&lt;!&ndash;        <h1 v-if="title2">祝新老客户</h1>&ndash;&gt;-->
    <!--&lt;!&ndash;        <h1 v-if="title3">新春快乐</h1>&ndash;&gt;-->
    <!--&lt;!&ndash;      </div>&ndash;&gt;-->
    <!--    </el-dialog>-->

    <navigation-bar-component v-if="!$route.meta.singlePage" />
    <router-view />
    <footer-component v-if="!$route.meta.singlePage" />
    <PreLoad></PreLoad>
  </div>
</template>

<script>
import navigationBarComponent from "@/components/navigationBarComponent/navigationBarComponent";
import footerComponent from "@/components/footerComponent/footerComponent";
import PreLoad from "@/components/preload";

export default {
  name: "App",
  components: { navigationBarComponent, footerComponent, PreLoad },
  data() {
    return {
      open: false,
      // title1: false,
      // title2: false,
      // title3: false
    };
  },
  created() {
    // if (!this.$route.meta.singlePage) this.open = true
  },
  methods: {
    onVideoEnded() {
      setTimeout(() => {
        this.$refs.videoPlayer
          .play()
          .then(() => {
            // 视频能够播放时的操作
          })
          .catch((error) => {
            // 处理播放错误
            console.error("Error playing video:", error);
          });
      }, 1000);
    },
    // imageLoaded () {
    //   console.log('图片加载完成')
    //   setTimeout(() => {
    //     this.title1 = true
    //     setTimeout(() => {
    //       this.title2 = true
    //       setTimeout(() => {
    //         this.title3 = true
    //       }, 300)
    //     }, 300)
    //   }, 500)
    // },
    // imageLoadError () {
    //   console.error('图片加载错误')
    // }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.el-dialog__header,
.el-dialog__body {
  padding: 0 !important;
}

.el-dialog {
  background: rgba(255, 255, 255, 0) !important;
  -webkit-box-shadow: none !important;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 960px;
}

.el-dialog__headerbtn {
  display: none;
}

/*.img_newYear {*/
/*  position: absolute;*/
/*  top: 95px;*/
/*  left: 10px;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  font-size: 1.5rem;*/
/*  color: #faf668;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue